module.exports = __webpack_public_path__ + "img/second-place.539a4d3e.png";